import { default as reducer } from "./reducer";

export default reducer;

export { detectFeatures as detectPersonalizedFeatures } from "./actions";

export { fetchMachines as fetchOriginalSupplyMachines } from "./originalSupply/actions";
export { fetchOrderHistoryDocument, fetchLatestOrderHistory } from "./orderHistory/actions";
export { fetchSalesRecommendation } from "./proactiveSales/actions";

export {
  // personalized area
  getPersonalizedFeatures,
  getPersonalizedFeatureList,
  // original supply
  getMachines as getOriginalSupplyMachines,
  getSelectedMachine,
  getSelectedMachineNumber,
  getCurrentItemLabel,
  getPreviousItemLabel,
  // order history
  getOrderHistoryDocument,
  getOrderHistoryDocumentIsFetching,
  getOrderHistoryDocumentHasError,
  // latest orders and quotes
  getLatestOrders,
  getLatestQuotes,
  getOrdersCount,
  getQuotesCount
} from "./selectors";
